import { useMutation } from '@tanstack/react-query';
import { axiosGlobalInstance } from 'api/axios/global';
import { routes } from 'api/routes';

const post = async <T>(values: T) => {
  return axiosGlobalInstance.post(routes['resetPassword'], values);
};

const usePostResetPassword = <T>() => {
  return useMutation({
    mutationFn: post<T>,
  });
};

export default usePostResetPassword;
